import React, { useMemo } from 'react'
import { DateTime } from 'luxon'

export default function DateTimeInput({ value, ...props }) {
  function onChange(e) {
    if (!props.onChange) return
    const target = e.currentTarget || e.target
    const lxDt = DateTime.fromISO(target.value)
    if (lxDt.isValid) {
      const change = { [target.name]: lxDt.toISO() }
      props.onChange(change)
    } else {
      console.error('onChange invalid date', target.value, lxDt.invalidReason)
    }
  }
  const htmlValue = useMemo(() => value ? DateTime.fromISO(value).toLocal().toISO().slice(0, 16) : value, [value])

  return <input {...props} type='datetime-local' value={htmlValue} onChange={onChange} />
}
